import React, {useEffect, useState, useRef} from 'react'
import API from '../../services/api'
import TableLoader from '../../shared/TableLoader'
import { SlDrawer, SlIcon, SlTooltip } from '@shoelace-style/shoelace/dist/react'
import NoDataFound from '../../shared/NoDataFound'
import ScrollContainer from 'react-indiana-drag-scroll'
import config from '../../config'
import { useNavigate } from 'react-router-dom'
import Paginator from '../../shared/Paginator'
import { roles } from '../../utils/constants';
import { CSVLink } from "react-csv";
import { debounce } from '../../utils/Debounce'
import { Toast } from '../../shared/Toast'

function SalesPersonWiseSales() {
    const navigate = useNavigate()
    const [loader, setLoader] = useState(false)
    const [salesPersonWiseData, setSalesPersonWiseData] = useState([])
    const [totalPages, setTotalPages] = useState(0)
    const [search, setSearch] = useState('')
    const [currentPage, setCurrentPage] = useState(0)
    const [downloadData, setDownloadData] = useState([])
    const [downloadLoader, setDownloadLoader] = useState(false)
    const [showInvoice, setShowInvoice] = useState(false)
    const [invoiceData, setInvoiceData] = useState([])

    const fetchSalesPersonWiseData = async() =>{
        try {
            let res = await API({
                url: 'finance_panel/sales-person-wise',
                method: 'POST',
                responseType: 'json',
                data:{
                    search: search,
                    limit:config.PER_PAGE,
                    offset:currentPage
                }
            })
        if(res.code === 200){
            setSalesPersonWiseData(res.data?.data)
            setTotalPages(Math.ceil(res.data?.totalCounts / config.PER_PAGE));

        }
        } catch (error) {
            console.log(error)
        }
        finally{
            setLoader(false)
        }
    }

    const csvLinkRef = useRef(); // Create a ref for CSVLink
    let csvHeaders = [
      { label: "sales Person", key: "name" },
      { label: "Total Amount", key: "total_invoice_amount" },
      { label: "Payment", key: "total_payment" },
      { label: "Due", key: "total_due" },
      { label: "Mobile", key: "mobile" },
  ];

    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
      };
      const downloadReport = async (
      ) => {
          setDownloadLoader(true);
          try {
        let result = await API({
            url: "/finance_panel/sales-person-wise-report-download",
            method: "POST",
            responseType: "json",
            data: {
              search:search
            },
        });
        if (result?.code === 200) {
            setDownloadLoader(false);
            setDownloadData(result.data);
        }
          } catch (error) {
        setDownloadLoader(false);
        console.error(error);
        if (error.response.status === 401) navigate("/");
          }
      };
      useEffect(() => {
        if (downloadData.length) {
            csvLinkRef?.current?.link?.click();
            setDownloadData([]);
        }
      }, [downloadData]);

    useEffect(() => {
        fetchSalesPersonWiseData()
    }, [search, currentPage])

    const fetchInvoices = async (due, sales_id) => {
        if(due <= 0){
          Toast('warning', 'No data to show!')
          return 
        }
        try {
            let res = await API({
                url: '/finance_panel/sales-person-wise-invoice',
                method: 'POST',
                responseType: 'json',
                data:{
                    sales_id
                }
            })
        if(res.code === 200){
          setInvoiceData(res.data)
          if(res.data.length > 0){
            setShowInvoice(true)
          }
          else{
            Toast('warning', 'No data to show!')
          }
        }
      }
      catch(error){
        console.error(error)
      }
    }

    function handleRequestClose(event) {
      if (event.detail.source === "overlay") {
        event.preventDefault();
      }
    }
  return (
    <>
    <h5>Sales Person Wise Sales</h5>
    <div className='d-flex  gap-3 flex-wrap justify-end ml-auto mb-2 items-center'>
        <input type="text" className='form-control max-w-[280px]' placeholder='Sales Person' onChange={
            debounce((e) => setSearch(e.target.value), 500)}/>
        {( localStorage.getItem('role') === roles.financer) &&<div >
          <CSVLink
              data={downloadData.map(
                  ({
                    name,
                    mobile,
                    total_invoice_amount,
                    total_payment,
                    total_due,
                  }) => {
                    let obj = {
                      name,
                        mobile,
                      total_payment,
                      total_invoice_amount,
                      total_due,
                    };
  
                    return obj;
                  }              )}
              headers={csvHeaders}
              filename={"sales_wise_report.csv"}
              ref={csvLinkRef} // Assign the ref to the CSVLink component
          ></CSVLink>

          {downloadLoader ? (
              <TableLoader />
          ) : (
              <SlTooltip content="Export">
                  <SlIcon
                      library="lucide"
                      name="download"
                      className="w-6 h-6 cursor-default hover:text-sky-300 mr-1"
                      onClick={() => {
                          downloadReport(search)
                      }}
                  ></SlIcon>
              </SlTooltip>
          )}
        </div>}
        </div>
        <ScrollContainer>
        <table className='table table-bordered'>
            <thead>
                <tr>
                    <th>Sales Person</th>
                    <th>Sales</th>
                    <th>Mobile</th>
                    <th>Payments</th>
                    <th>Dues</th>
                    </tr>
                </thead>
                {
                    !loader && salesPersonWiseData.length > 0  ?<tbody> {
                        salesPersonWiseData.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <td>{item.name}</td>
                                    <td>{item.total_invoice_amount}</td>
                                    <td>{item.mobile}</td>
                                    <td>{item.total_payment}</td>
                                    <td><span onClick={()=>{fetchInvoices(item.total_due, item.sales_person_id)}} className='hover:text-blue-500 cursor-pointer hover:underline'>{item.total_due}</span></td>
                                </tr>
                            )
                        })
                    }</tbody> : loader ? <TableLoader colspan={5} /> : <NoDataFound colspan={5} />
                }
        </table>
        </ScrollContainer>
        <div className="flex justify-end">
        {totalPages > 1 && (
          <Paginator
            pageCount={totalPages}
            handlePageClick={handlePageClick}
            forcePage={currentPage}
          />
        )}
      </div>

      <SlDrawer open={showInvoice}
        onSlRequestClose={handleRequestClose} label='Invoices'>
          <table className='table table-bordered'>
              <thead>
                <tr>
                  <th>Invoice No</th>
                  <th>Amount</th>
                  <th>Due</th>
                </tr>
              </thead>
              <tbody>
                {invoiceData.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{item.invoice_no}</td>
                      <td>{item.amount}</td>
                      <td>{item.amount - item.total_payment}</td>
                    </tr>
                  )
                })}
              </tbody>
          </table>
      </SlDrawer>
    </>
  )
}

export default SalesPersonWiseSales